import { useState } from "react";
import { Button, Menu, MenuItem, Checkbox, ListItemText, List, ListItemButton } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
	roleData: any;
	selectedRoles: string[];
	onSave: (roles: string[]) => void;
}

const RoleDropdown = (props: Props) => {
	const [t] = useTranslation();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectedRoles, setSelectedRoles] = useState<string[]>(JSON.parse(JSON.stringify(props.selectedRoles)));

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setSelectedRoles(JSON.parse(JSON.stringify(props.selectedRoles)));
		setAnchorEl(event.currentTarget);
	};

	const handleSave = () => {
		props.onSave(selectedRoles);
		handleClose();
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleToggle = (roleId: string) => () => {
		const currentIndex = selectedRoles.indexOf(roleId);
		const newSelectedRoles = [...selectedRoles];

		if (currentIndex === -1) {
			newSelectedRoles.push(roleId);
		} else {
			newSelectedRoles.splice(currentIndex, 1);
		}

		setSelectedRoles(newSelectedRoles);
	};

	const open = Boolean(anchorEl);

	return (
		<div style={{ marginRight: "16px" }}>
			<Button
				color="success"
				variant="text"
				onClick={handleClick}
				endIcon={open ? <span className="material-icons">keyboard_arrow_down</span> : <span className="material-icons">keyboard_arrow_up</span>}
				style={{ color: "#333", textTransform: "none" }}
			>
				{t("userSystem.roleName")}
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				<div className="p-2">
					<List>
						{props.roleData.map((role: any) => (
							<ListItemButton
								key={role.id}
								dense
								onClick={handleToggle(role.id)}
								selected={selectedRoles.indexOf(role.id) !== -1}
								color="success"
							>
								<Checkbox
									size="small"
									edge="start"
									color="success"
									checked={selectedRoles.indexOf(role.id) !== -1}
									disableRipple
								/>
								<ListItemText primary={role.roleName} />
							</ListItemButton>
						))}
					</List>
					<div style={{ marginTop: "8px", display: "flex", justifyContent: "space-between" }}>
						<Button
							color="success"
							disabled={selectedRoles.length === 0}
							onClick={() => setSelectedRoles([])}
						>
							{t("buttons.reset")}
						</Button>
						<div>
							<Button
								color="success"
								onClick={handleClose}
							>
								{t("buttons.close")}
							</Button>
							<Button
								variant="contained"
								color="success"
								onClick={handleSave}
							>
								{t("buttons.save")}
							</Button>
						</div>
					</div>
				</div>
			</Menu>
		</div>
	);
};

export default RoleDropdown;
